import { render, staticRenderFns } from "./CommissionPV.vue?vue&type=template&id=24994798&"
import script from "./CommissionPV.vue?vue&type=script&lang=js&"
export * from "./CommissionPV.vue?vue&type=script&lang=js&"
import style0 from "./CommissionPV.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports